import { render, staticRenderFns } from "./ControlAwning.vue?vue&type=template&id=36e96f86&scoped=true&"
import script from "./ControlAwning.vue?vue&type=script&lang=ts&"
export * from "./ControlAwning.vue?vue&type=script&lang=ts&"
import style0 from "./ControlAwning.vue?vue&type=style&index=0&id=36e96f86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e96f86",
  null
  
)

export default component.exports